import React, { useCallback, useEffect, useState } from "react";

import { getBarPress } from "keplerConfigs/config/homeMap/dataset/metrics/barPress";
import GeneralKeplerMapContainer from "containers/kepler-maps/GeneralKeplerMap.container";
import { useTranslation } from "react-i18next";
import { mapStateConfig } from "keplerConfigs/config/mapStateConfig";
import { mapStyleConfig } from "keplerConfigs/config/mapStyleConfig";
import { getHeatmapConfigBarPressNorm } from "keplerConfigs/config/environmentMapConfig/heatmapConf/barPress";
import { getPointConfigBarPressHeatmap } from "keplerConfigs/config/environmentMapConfig/pointsConf/barPress";
import { Box } from "@mui/material";
import BarPressIcon from "assets/icons/BarPress.icon";
import FiltersComponent from "components/filtersMap/Filters.component";
import LegendMetricComponent from "components/kleperMap/legend/LegendMetric.component";
import { propsLegendMetric } from "constants/metrics";
import _ from "lodash";
const MapBarPressContainer = ({ data }) => {
  const [config, setConfig] = useState({});

  const { t } = useTranslation();

  const createInteractionConfig = useCallback(() => {
    let configInteraction = {
      tooltip: {
        fieldsToShow: {
          bar_press: [
            {
              name: "ID",
              format: null,
            },
            {
              name: "Cluster",
              format: null,
            },
            {
              name: t("Address"),
              format: null,
            },
            {
              name: t("atmospheric-pressure"),
              format: null,
            },
          ],
        },
        compareMode: false,
        compareType: "absolute",
        enabled: true,
      },
      brush: {
        size: 0.5,
        enabled: false,
      },
      geocoder: {
        enabled: false,
      },
      coordinate: {
        enabled: false,
      },
    };
    return configInteraction;
  }, [t]);

  const createLayers = useCallback(() => {
    const layersConfig = [
      getPointConfigBarPressHeatmap(t("atmospheric-pressure")),
      getHeatmapConfigBarPressNorm(t("atmospheric-pressure")),
    ];
    return layersConfig;
  }, [t]);

  useEffect(() => {
    if (data && !_.isEmpty(data)) {
      const fields = [
        {
          name: "ID",
          type: "string",
          format: "",
          analyzerType: "STRING",
        },
        {
          name: "lat",
          type: "real",
          format: "",
          analyzerType: "FLOAT",
        },
        {
          name: "lon",
          type: "real",
          format: "",
          analyzerType: "FLOAT",
        },
        {
          name: 'Cluster',
          format: null,
        },
        {
          name: t("Address"),
          format: null,
        },
        {
          name: t("atmospheric-pressure"),
          type: "real",
          format: "",
          analyzerType: "real",
        },
        {
          name: 'data_norm',
          type: "real",
          format: "",
          analyzerType: "real",
        },
      ]
      const dataHeatmap = getBarPress(
        data,
        t("atmospheric-pressure"), fields
      );
      const newConfig = {
        datasets: dataHeatmap,
        options: {
          centerMap: true,
          readOnly: true,
        },
        config: {
          visState: {
            filters: [],
            interactionConfig: createInteractionConfig(),
            layers: createLayers(),
            layerBlending: "normal",
            splitMaps: [],
            animationConfig: {
              currentTime: null,
              speed: 1,
            },
          },
          mapState: mapStateConfig,
          mapStyle: mapStyleConfig,
        },
      };
      setConfig(newConfig);
    }
    // eslint-disable-next-line
  }, [data, t]);

  return (
    <Box sx={{ position: "relative", height: "100%" }}>
      <GeneralKeplerMapContainer height={400} config={config} zoom={12} />
      <Box sx={{ position: "absolute", top: 10, left: 10 }}>
        <LegendMetricComponent {...propsLegendMetric.bar_press} />
      </Box>

      <Box
        sx={{
          position: "absolute",
          top: 20,
          right: 15,
          display: { xs: "none", sm: "block" },
        }}
      >
        <FiltersComponent
          options={[
            {
              label: t("atmospheric-pressure"),
              name: "bar_press",
              icon: <BarPressIcon fontSize="inherit" width={22} height={22} />,
            },
          ]}
          checked={{ bar_press: true }}
          width={115}
        />
      </Box>
    </Box>
  );
};

export default MapBarPressContainer;
